import PropTypes from 'prop-types';
import { Navigate } from 'react-router';
import { PATH_ONLINE } from 'src/routes/paths';

// ----------------------------------------------------------------------

export default function GuestGuard({ children }) {
  //TODO: REMOVE
  const isAuthenticated = true;

  if (isAuthenticated) {
    return <Navigate to={PATH_ONLINE.root} />;
  }

  return <>{children}</>;
}
GuestGuard.propTypes = {
  children: PropTypes.node,
};
